export const IFAST_CHARGE_ONLINE = 0.3;
export const IFAST_CHARGE_PAPER = 0.5;
export const WRAP_IFAST_RATE_ONLINE = 0.06;
export const WRAP_IFAST_RATE_PAPER = 0.1;

export const resolveIfastChargeMinimum = (submissionVia) =>
  submissionVia === "Paper" ? IFAST_CHARGE_PAPER : IFAST_CHARGE_ONLINE;

export const resolveWrapIfastChargeRate = (submissionVia) =>
  submissionVia === "Paper" ? WRAP_IFAST_RATE_PAPER : WRAP_IFAST_RATE_ONLINE;

export const resolveNonWrapEffectiveMinimum = ({ submissionVia, settingsMin }) =>
  Math.max(settingsMin ?? 0, resolveIfastChargeMinimum(submissionVia));

const toFeeNumber = (value) => {
  if (value === "" || value == null || value === undefined) return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

const resolveIfastCharge = ({ accountType, submissionVia, totalCharge }) => {
  if (accountType === "NonWrap") {
    return resolveIfastChargeMinimum(submissionVia);
  }
  if (accountType === "Wrap") {
    return Number(
      (totalCharge * resolveWrapIfastChargeRate(submissionVia)).toFixed(2)
    );
  }
  return null;
};

export const buildCommissionChargeSummary = ({ submissionVia, commission = {} }) => {
  const accountType = commission.accountType;
  if (!accountType) return null;

  let totalCharge = null;

  if (accountType === "NonWrap") {
    totalCharge = toFeeNumber(commission.upfrontFee ?? commission.switchFee);
  } else if (accountType === "Wrap") {
    totalCharge = toFeeNumber(commission.upfrontWrapFee);
  }

  if (totalCharge == null) return null;

  const ifastCharge = resolveIfastCharge({ accountType, submissionVia, totalCharge });

  return {
    accountType,
    totalCharge,
    ifastCharge,
    fpCharge: Number((totalCharge - ifastCharge).toFixed(2)),
  };
};
